const APP_ERROR_MESSAGE = 'Ne pare rau, a intervenit o eroare la aplicatie!'
import axios from '@/axios.js';

export default {
    notification({ commit, state }, response) {
        if (response.status && response.status == 404) {
            commit('NOTIFICATION', {
                type: 'error',
                message: APP_ERROR_MESSAGE
            });
        } else {
            state.notification.icon = null;
            state.notification.title = null;

            if(response.data.message === undefined)
                return;
            
            if (response.data.success === false) {setTimeout(() => {commit('NOTIFICATION', { type: 'warning', message: response.data.message });}, 200);} 
            else if (response.status === 200) {setTimeout(() => {commit('NOTIFICATION', { type: 'success', message: response.data.message });}, 200);} 
            else {commit('NOTIFICATION', { type: 'error', message: response.data.message });}
        }
    },
    oldNotification({ commit, state }, response)  {//old logic - too complicated

        if(response.status == 404) {
            commit('NOTIFICATION', { 
                type: 'error', 
                message: APP_ERROR_MESSAGE
            });
        } else {

            if(response.data.success === false) {
                commit('NOTIFICATION', { type: 'warning', message: response.data.message });
            } else if(response.status === 200) {
                if (
                    state.notification.title === response.data.message
                    || state.notification.icon === 'success'
                ) {
                    state.notification.icon = null;
                    state.notification.title = null;
    
                    setTimeout(() => {
                        commit('NOTIFICATION', { type: 'success', message: response.data.message });
                    }, 200);
                } else {
                    commit('NOTIFICATION', { type: 'success', message: response.data.message });
                }
            } else if (
                state.notification.title === response.data.message
                || state.notification.icon === 'error'
            ) {
                state.notification.icon = null;
                state.notification.title = null;
    
                setTimeout(() => {
                    commit('NOTIFICATION', { type: 'error', message: response.data.message });
                }, 200);
            } else { 
                commit('NOTIFICATION', { type: 'error', message: response.data.message });
            }
        }
    },
    async fetchNotifications({ commit, state }, index) {
        state.isLoading = true;
        
        axios.get(`/notifications?page=${index}`)
        .then(function (response) {
            commit('FETCH_PAGE_NOTIFICATIONS', {
                response: response,
                index: index
            });
        })
        .catch(function (error) {
            console.error(error);
        });
    }
}
